
import initVue, { http, setEnableRole, setSidebarMenu }  from './core'

import App from './views/App'
import appStore from './app.store'
import routes from './app.routes'
import config from './app.config'
// import menuData from './app.menu'

import './assets/css/main.scss'

//todo 设置是否开启权限

setEnableRole(true);

//设置导航菜单
// setSidebarMenu(menuData);
if(process.env.NODE_ENV == 'production' || process.env.NODE_ENV == 'prod'){
    console.log=()=>{}
}
http.config({
    baseURL: config.baseURL,
    timeout: config.timeout,
    withCredentials: config.withCredentials
});

initVue({
    el: '#app',
    store: appStore,
    routes,
    App
});
